import {
  UNSAVED_CHANGES_NAMED_INIT,
  UNSAVED_CHANGES_NAMED_SUCCESS,
  UNSAVED_CHANGES_UNNAMED_INIT,
  UNSAVED_CHANGES_UNNAMED_SUCCESS,
  UNSAVED_CHANGES_PROJECT_DETAILS_INIT,
  UNSAVED_CHANGES_PROJECT_DETAILS_SUCCESS,
  UNSAVED_CHANGES_GANTT_BY_DEP_INIT,
  UNSAVED_CHANGES_GANTT_BY_DEP_SUCCESS,
  UNSAVED_CHANGES_GANTT_NOTIFICATIONS_INIT,
  UNSAVED_CHANGES_GANTT_NOTIFICATIONS_SUCCESS,
  UNSAVED_CHANGES_GANTT_NOTIFICATIONS_UNNAMED_INIT,
  UNSAVED_CHANGES_GANTT_NOTIFICATIONS_UNNAMED_SUCCESS,
} from "../actions/types/common-types";

export const initialState = {
  unsavedChangesNamed: false,
  unsavedChangesUnnamed: false,
  unsavedChangesProjectDetails: false,
  unsavedChangesGanttByDep: false,
  unsavedChangesGanttNotifications: false,
  unsavedChangesGanttNotificationsUnnamed: false,
};

const handlers = {
  [UNSAVED_CHANGES_NAMED_INIT]: (state) => ({
    ...state,
    unsavedChangesNamed: false,
  }),
  [UNSAVED_CHANGES_NAMED_SUCCESS]: (state, action) => ({
    ...state,
    unsavedChangesNamed: action.val,
  }),
  [UNSAVED_CHANGES_UNNAMED_INIT]: (state) => ({
    ...state,
    unsavedChangesUnnamed: false,
  }),
  [UNSAVED_CHANGES_UNNAMED_SUCCESS]: (state, action) => ({
    ...state,
    unsavedChangesUnnamed: action.val,
  }),
  [UNSAVED_CHANGES_PROJECT_DETAILS_INIT]: (state) => ({
    ...state,
    unsavedChangesProjectDetails: false,
  }),
  [UNSAVED_CHANGES_PROJECT_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    unsavedChangesProjectDetails: action.val,
  }),
  [UNSAVED_CHANGES_GANTT_BY_DEP_INIT]: (state) => ({
    ...state,
    unsavedChangesGanttByDep: false,
  }),
  [UNSAVED_CHANGES_GANTT_BY_DEP_SUCCESS]: (state, action) => ({
    ...state,
    unsavedChangesGanttByDep: action.val,
  }),
  [UNSAVED_CHANGES_GANTT_NOTIFICATIONS_INIT]: (state) => ({
    ...state,
    unsavedChangesGanttNotifications: false,
  }),
  [UNSAVED_CHANGES_GANTT_NOTIFICATIONS_SUCCESS]: (state, action) => ({
    ...state,
    unsavedChangesGanttNotifications: action.val,
  }),
  [UNSAVED_CHANGES_GANTT_NOTIFICATIONS_UNNAMED_INIT]: (state) => ({
    ...state,
    unsavedChangesGanttNotificationsUnnamed: false,
  }),
  [UNSAVED_CHANGES_GANTT_NOTIFICATIONS_UNNAMED_SUCCESS]: (state, action) => ({
    ...state,
    unsavedChangesGanttNotificationsUnnamed: action.val,
  }),
};

export default function commonReducer(state = initialState, action) {
  const handler = handlers[action.type];
  if (!handler) return state;
  return { ...state, ...handler(state, action) };
}
